export const RemoteIconSound = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_158048_12168)">
                <path
                    d="M11.6668 1.75V9.91667C11.6667 10.4303 11.4971 10.9295 11.1844 11.337C10.8716 11.7444 10.4332 12.0372 9.93703 12.1701C9.44089 12.3029 8.91477 12.2684 8.44027 12.0717C7.96577 11.8751 7.5694 11.5274 7.31264 11.0826C7.05588 10.6377 6.95307 10.1206 7.02015 9.61139C7.08724 9.10216 7.32047 8.6293 7.68368 8.26613C8.04688 7.90297 8.51977 7.66979 9.029 7.60276C9.53823 7.53574 10.0554 7.63861 10.5002 7.89542V3.5H5.25017V9.91667C5.25005 10.4303 5.08047 10.9295 4.76771 11.337C4.45496 11.7444 4.01651 12.0372 3.52036 12.1701C3.02422 12.3029 2.4981 12.2684 2.0236 12.0717C1.5491 11.8751 1.15274 11.5274 0.895976 11.0826C0.639214 10.6377 0.536403 10.1206 0.603487 9.61139C0.670571 9.10216 0.903802 8.6293 1.26701 8.26613C1.63022 7.90297 2.1031 7.66979 2.61234 7.60276C3.12157 7.53574 3.63869 7.63861 4.0835 7.89542V1.75H11.6668Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_158048_12168">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
